export default function inventoryListBlock(invList) {
  return {
    inv_result_count: invList.count.toString() || '0',
    inv_layout: invList.layout || '',
    inv_filter: invList.filter || '',
    inv_selector: invList.selector || '',
  };
};
